import { Badge, BadgeProps, Flex, Icon } from "@chakra-ui/react"
import { MdRocketLaunch } from "react-icons/md"

const TurboBadge = (props: BadgeProps) => {
  return (
    <Badge
      fontSize={"xs"}
      colorScheme={"yellow"}
      borderRadius={8}
      {...props}
    >
      <Flex
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Icon as={MdRocketLaunch} />
        {"Turbo"}
      </Flex>
    </Badge>
  )
}

export default TurboBadge
